import { Gem, Hammer, PenTool } from "lucide-react";
import { ASSETS } from "@/data/site";
import { Reveal, SectionHeading } from "@/components/Reveal";

const PILLARS = [
  { icon: Hammer, title: "Craftsmanship", desc: "Attention to detail at every stage." },
  { icon: PenTool, title: "Custom Design", desc: "Every creation developed specifically for its space." },
  { icon: Gem, title: "Timeless Material", desc: "Natural and engineered stone, designed to remain beautiful for generations." },
];

export default function About() {
  return (
    <section data-testid="about-section" className="bg-ivory py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
        <div className="grid items-center gap-16 lg:grid-cols-2">
          <Reveal>
            <div className="spotlight-frame overflow-hidden rounded-2xl">
              <img
                src={ASSETS.treeReception}
                alt="Tree of life carved reception wall installed by ShilpStones"
                className="aspect-[4/5] w-full object-cover"
              />
            </div>
          </Reveal>

          <div>
            <SectionHeading
              align="left"
              eyebrow="About ShilpStones"
              title="Crafted by Us. Inspired by Stone."
              script="Crafting Spaces with Soul"
              description="ShilpStones Creations brings together traditional craftsmanship and contemporary design to create exceptional stone art and architectural elements. Every project is developed around the character of the stone, the vision of the client and the identity of the space."
            />
            <div className="mt-10 space-y-0">
              {PILLARS.map((p, i) => (
                <Reveal key={p.title} delay={i * 0.12}>
                  <div className="flex items-start gap-5 border-t border-stone-200 py-6 last:border-b" data-testid={`about-pillar-${i}`}>
                    <span className="rounded-full border border-gold/40 bg-gold/10 p-3">
                      <p.icon className="h-5 w-5 text-gold-dark" />
                    </span>
                    <div>
                      <h3 className="font-display text-sm font-semibold uppercase tracking-[0.25em] text-stone-900">{p.title}</h3>
                      <p className="mt-1.5 text-sm text-stone-600">{p.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>

        <Reveal delay={0.15}>
          <div
            data-testid="client-visit-card"
            className="mt-20 grid overflow-hidden rounded-2xl bg-white shadow-[0_25px_70px_-20px_rgba(154,123,44,0.35)] ring-2 ring-gold/50 lg:grid-cols-[1fr,1.3fr]"
          >
            <div className="grid grid-cols-2 items-center gap-2 bg-taupe p-2">
              <img
                src={ASSETS.clientVisit}
                alt="Client from the USA visiting the ShilpStones plant"
                className="h-48 w-full rounded-lg object-contain"
              />
              <img
                src={ASSETS.clientVisit2}
                alt="USA client with the ShilpStones team at the studio office"
                className="h-48 w-full rounded-lg object-contain"
              />
            </div>
            <div className="flex flex-col justify-center p-8 sm:p-12 lg:p-16">
              <p className="font-display text-xs font-semibold uppercase tracking-[0.3em] text-gold-dark sm:text-sm">
                Trusted Worldwide
              </p>
              <p className="mt-3 font-serif text-2xl italic text-stone-900 sm:text-4xl">
                From Udaipur to the USA
              </p>
              <p className="mt-4 text-base leading-relaxed text-stone-600 sm:text-lg">
                A visit to our Plant &amp; Store — clients walk through our Bhilo ka Bedala plant
                and Sukher store from across the globe. Pictured: our client from the USA.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
